import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { clearStoredMeetings } from '@/features/meetings/storedMeeting';
import { meKey } from '@/features/auth/api';
import { ApiError } from '@/shared/api/client';

export function makeQueryClient(): QueryClient {
  // Сервер ответил «нужен вход» — сеанс закончился (выход на другом устройстве, истёк срок):
  // забываем пользователя, и интерфейс сам уводит на страницу входа.
  const onError = (error: unknown) => {
    if (error instanceof ApiError && error.status === 401 && client.getQueryData(meKey) !== null) {
      client.setQueryData(meKey, null);
      clearStoredMeetings();
    }
  };
  const client: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // Данные не старше 10 секунд не запрашиваются заново при каждом открытии экрана (раньше — каждый раз): меньше запросов и миганий.
        // Свежесть держат события реального времени и invalidateQueries после действий; запросы со своим staleTime не затронуты.
        staleTime: 10_000,
        // Данные живут в памяти (и в копии на устройстве) сутки, а не стандартные 5 минут: ушёл из «Дел» или «Календаря» и вернулся —
        // всё на месте сразу, свежее приходит следом. Скелетон — только когда данных правда ещё не было.
        gcTime: 24 * 3600_000,
        // Ошибки 4xx повторять бессмысленно; 504 — сервер перегружен и не успел ответить: повтор только добавит нагрузки.
        retry: (count, error) => !(error instanceof ApiError && (error.status < 500 || error.status === 504)) && count < 2,
      },
    },
  });
  return client;
}
